// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"708e5ca4","356":"25568d0c"}[chunkId] + ".chunk.css";
};